import { initializeApp } from 'firebase/app';
import { getDatabase } from 'firebase/database';
import { getAuth } from 'firebase/auth';

// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAx5ihPcFPoPvsjVdcEtTtnFvR1pM5dtVg",
  authDomain: "satyasocialaudit.firebaseapp.com",
  databaseURL: "https://satyasocialaudit-default-rtdb.firebaseio.com",
  projectId: "satyasocialaudit",
  storageBucket: "satyasocialaudit.appspot.com",
  messagingSenderId: "966746916907",
  appId: "1:966746916907:web:cb0a43bc4867fcde0c026e",
  measurementId: "G-WMMZV579RW"
};

const app = initializeApp(firebaseConfig);
const db = getDatabase(app);
const auth = getAuth(app);

export { db, auth };
